module.exports = __webpack_public_path__ + "assets/img/pic.0dbda4ee.png";